/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, formatFecha, Boton, TablaFiltrable } from "../../shared";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";

const FILTROS = [
  { campo: "_tipoProducto", label: "Tipo de producto", labelPlural: "tipos de producto" },
  { campo: "_clienteText", label: "Cliente", labelPlural: "clientes" },
];
const SEARCH_FIELDS = ["_clienteText", "_tipoProducto"];

export default function ImportacionesPendientes({ toast }) {
  const [importaciones, setImportaciones] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/importacion/pendientes",
      null,
      (respuesta) => {
        setImportaciones(respuesta);
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar importaciones",
          sticky: true,
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (!loading && (!importaciones || importaciones.length === 0)) {
    return null;
  }

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  function marcarComoVisto(importacionId) {
    accessAPI(
      "PUT",
      `admin/importacion/${importacionId}/visto`,
      null,
      () => {
        setImportaciones((prev) => prev.filter((i) => i.id !== importacionId));
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al marcar como visto",
          sticky: true,
        });
      }
    );
  }

  const datos = importaciones.map((i) => ({
    ...i,
    _tipoProducto: i.certificadotipo?.nombre || "-",
    _clienteText: i.cliente?.razonsocial || "-",
  }));

  return (
    <Accordion
      activeIndex={null}
      css={{
        marginTop: "1em",
        "& .p-accordion-header-link": { color: "black" },
        "& .p-toggleable-content": { transition: "max-height 0.15s ease" },
      }}
    >
      <AccordionTab header={`Nuevas importaciones de clientes (${importaciones.length})`}>
        <TablaFiltrable
          value={datos}
          filtros={FILTROS}
          searchFields={SEARCH_FIELDS}
          busquedaAlFinal
          anchoBusqueda="33%"
          nombreArchivo="importaciones_pendientes"
          size="small"
          emptyMessage="No hay importaciones nuevas"
          onRowClick={(e) => {
            if (e.originalEvent.target.closest("button")) return;
            navigate(`/clientes/${e.data.clienteId}/procesos`);
          }}
          rowClassName={() => "cursor-pointer"}
        >
          <Column field="_clienteText" header="Cliente" />
          <Column field="_tipoProducto" header="Tipo de producto" />
          <Column
            header="Cantidad"
            body={(i) => i.cantidad || "-"}
            style={{ width: "10em" }}
            alignHeader="center"
            bodyStyle={{ textAlign: "center" }}
          />
          <Column
            header="Fecha de importación"
            body={(i) => formatFecha(i.fechaImportacion)}
            style={{ width: "12em" }}
            alignHeader="center"
            bodyStyle={{ textAlign: "center" }}
          />
          <Column
            body={(i) => (
              <Boton callback={() => marcarComoVisto(i.id)} chico texto>
                Marcar como visto
              </Boton>
            )}
            style={{ width: "12em" }}
          />
        </TablaFiltrable>
      </AccordionTab>
    </Accordion>
  );
}
